<template>
  <Modal
    v-model="_value"
    width="600"
    title="第三方监控确认对接订单"
    @on-visible-change="visibleChange"
    ok-text="确认"
    @on-ok="onOk">

    <Form v-if="orderList.length > 0" ref="loginForm" :model="monitoringserviceOrder" :label-width="80">
      <div v-for="item in orderList">
        <FormItem prop="registrationNum" label="车牌号">
          <label style="display: inline-block; width: 100px;">{{item.monitoringServiceTempVehicleInfo != null ? item.monitoringServiceTempVehicleInfo.registrationNum : item.vehicleInfo.registrationNum}}</label>
        </FormItem>
      </div>

      <FormItem prop="state" label="审核结果">
        <Select style="width: 100px;" v-model="orderListstepstate">
          <Option v-for="item in stepstateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="receptDatetime" label="确认时间" v-if="orderListstepstate == 2">
        <DatePicker type="date" v-model="monitoringserviceOrder.monitoringDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="result" label="不通过原因" v-if="orderListstepstate == 3">
        <Input style="display: inline-block; width: 400px;" type="textarea" v-model="monitoringserviceOrder.step.result"
               placeholder="不通过原因">
        </Input>
      </FormItem>
    </Form>

    <Form v-else ref="loginForm" :model="monitoringserviceOrder" :label-width="80">
      <FormItem prop="registrationNum" label="车牌号">
        <label style="display: inline-block; width: 100px;">{{monitoringserviceOrder.monitoringServiceTempVehicleInfo != null ? monitoringserviceOrder.monitoringServiceTempVehicleInfo.registrationNum : monitoringserviceOrder.vehicleInfo.registrationNum}}</label>
      </FormItem>
      <FormItem prop="state" label="审核结果">
        <Select style="width: 100px;" v-model="monitoringserviceOrder.step.state">
          <Option v-for="item in stepstateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="receptDatetime" label="确认时间" v-if="monitoringserviceOrder.step.state == 2">
        <DatePicker type="date" v-model="monitoringserviceOrder.monitoringDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="result" label="不通过原因" v-if="monitoringserviceOrder.step.state == 3">
        <Input style="display: inline-block; width: 400px;" type="textarea" v-model="orderListstepresult"
               placeholder="不通过原因">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'monitoringserviceconfirmmonitoringmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {
      stepstateOptions: [
        { label: '通过', value: 2 },
        { label: '不通过', value: 3 }
      ],
      //  对接订单
      monitoringserviceOrder: {
        if: null,
        totalAmount: 0,
        serviceDatetime: null,
        businessUserId: null,
        multiDevices: false,
        qghyptOption: 0,
        clientInfoId: null,
        remark: null,
        monitoringServicePackage: 1,
        billType: 1,
        vehicleInfoGroupId: null,
        positioningDeviceId: null,
        vehicleInfoId: null,
        reInstall: false,
        vehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            id: null,
            name: null
          },
          vehicleBrand: {
            id: null,
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            id: null,
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        monitoringServiceTempVehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            name: null
          },
          vehicleBrand: {
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          salesChannelId: null,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        urgent: '否',
        monitoringDatetime: null,
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        }
      },

      orderList: [],
      orderIds: [],
      orderListstepstate: null,
      orderListstepresult: null
    }
  },
  methods: {
    ...mapActions([
      'InstallOrderServ_ForceConfirmInstalled',
      'InstallOrderServ_GetDetail'
    ]),
    onOk () {
      if (this.orderList != null && this.orderList.length > 0) {
        store.dispatch('MonitoringServiceOrderServ_BatchConfirmmMonitoring', {
          params:
              {
                orderList: this.orderIds,
                state: this.orderListstepstate,
                result: this.orderListstepresult,
                monitoringDatetime: new Date(this.monitoringserviceOrder.monitoringDatetime).Format('yyyy-MM-dd hh:mm:ss')
              },
          urlparams: null
        }).then(() => {
          this.$Message.success('提交成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        console.log(this.monitoringserviceOrder)
        this.$Modal.confirm({
          title: '确认对接',
          onOk: () => {
            store.dispatch('MonitoringServiceOrderServ_ConfirmmMonitoring', { params: this.monitoringserviceOrder }).then(() => {
              this.$Message.success('提交成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.orderList = this._listValue
        this.orderIds = []
        if (this.orderList != null && this.orderList.length > 0) {
          this.orderList.forEach(item => {
            this.orderIds.push(item.id)
          })
        } else {
          this.orderIds = []

          this.monitoringserviceOrder.id = null
          this.monitoringserviceOrder.monitoringDatetime = null

          let monitoringserviceOrderId = this._initValue
          if (monitoringserviceOrderId) {
            store.dispatch('MonitoringServiceOrderServ_GetDetail', {
              params: { id: monitoringserviceOrderId }
            }).then(() => {
              this.monitoringserviceOrder = store.getters.get_MonitoringServiceOrder_GetDetailResult
              this.monitoringserviceOrder.monitoringDatetime = new Date()
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
